<template>
    <InformeCard
        id="resumen-plazos"
        name="resumen-plazos"
        collapsable="true"
        title="Resumen por mes de plazos"
    >
        <div class="row table-responsive" v-if="plazos_por_mes">
            <b-col cols="12">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Mes</th>
                            <th class="text-center">Pagados</th>
                            <th class="text-center">Pendientes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(plazo, index) in plazos_por_mes">
                            <tr :key="'plazo-' + index">
                                <td>{{ plazo.mes }}</td>
                                <td class="text-center">{{ plazo.pagados }}</td>
                                <td class="text-center">{{ plazo.pendientes }}</td>
                            </tr>
                        </template>
                        <tr class="tr-total lightgray-content">
                            <td><strong>TOTAL PAGADOS/PENDIENTES</strong></td>
                            <td class="text-center">{{ total_pagados }}</td>
                            <td class="text-center">{{ total_pendientes }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </div>
        <div v-else>
            No se ha realizado ningún pago a plazos
        </div>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['lista_id'],
        data() {
            return {
                plazos_por_mes: null,
            }
        },
        methods: {
            getPlazosPorMes() {
                this.loading = true;

                const params = {
                    lista_id: this.lista_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.informe.plazos-por-mes'), params).then(res => {
                    this.plazos_por_mes = res.data.plazos_por_mes;
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            total_pagados() {
                var total = 0;

                if (this.plazos_por_mes) {
                    this.plazos_por_mes.forEach(plazo => {
                        total = total += plazo.pagados;
                    });
                }

                return total;
            },
            total_pendientes() {
                var total = 0;

                if (this.plazos_por_mes) {
                    this.plazos_por_mes.forEach(plazo => {
                        total = total += plazo.pendientes;
                    });
                }

                return total;
            }
        },
        created() {
            this.getPlazosPorMes();
        },
        components: {
            InformeCard
        }
    }
</script>

